import { I18n } from "../services/I18n";
import "./generated/site-translations-en";
import common_en from "../../../../../libs/ps/restaumatic-common/locales/en.json";
import core_types_sites_en from "../../../../../libs/ps/restaumatic-core-types-sites/locales/en.json";
I18n.translations = I18n.translations || {};
I18n.translations = I18n.extend(I18n.translations, {
  en: { _core_types_sites: core_types_sites_en },
});
I18n.translations = I18n.extend(I18n.translations, {
  en: { _common: common_en },
});
